export default __webpack_public_path__ + "static/18-920bf82729d2eca1438dad72e08e101f.png";